/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-12-08 12:16:20
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-12-08 12:35:51
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorAppearance/LoadingAnimation/index.tsx
 */
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import React from 'react';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import _ImageWidthTitle from 'src/pages/SalesChannelContentEditor/Components/ImageWidthTitle';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useDispatch } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getLoadingAnimation,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onLoadingAnimationChange,
} from '../slice';
import { validateImageStateSetting } from '../tools';
import css from './css.less';

function LoadingAnimation(props) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const { data } = props;

  const handleImageChange = (img) => {
    _d(onLoadingAnimationChange(img));
  };
  return (
    <React.Fragment>
      <Section className={css.section}>
        <_ImageWidthTitle
          title={getI18n('general.checkImgDraggableDisplay.title')}
          image={data}
          subtitle={`${getI18n('general.allowedfiletypes')} :gif`}
          onImageChange={handleImageChange}
        />
      </Section>
    </React.Fragment>
  );
}

export default ErrorProcessingHOC(LoadingAnimation, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.loadingAnimation,
  getContent: getLoadingAnimation,
  title: getI18nFromGeneral('general.hOCTitle.loadingAnimation'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: validateImageStateSetting,
  getSubmitStamp: getSubmitStamp,
});
